import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import * as Section from "@repoflow/components/section";

import * as FileRoute from "./file";
import * as NewRoute from "./new";

const LocalProvider = ({ match: { params }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/file`;
  const basepath = `${parentBasepath}/file`;

  return (
    <Section.Provider
      schema={schema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath, parent }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:fileId`} component={FileRoute.Content} />
          <Route
            path={`${basepath}`}
            component={() => <Redirect to={parent.base} />}
          />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Indice} />
          <Route path={`${basepath}/:fileId`} component={FileRoute.Indice} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
